import React from 'react'
import styles from './index.module.scss'

export default function Error({
  message,
  errorClass,
}: {
  message: string
  errorClass?: string
}) {
  return <p className={errorClass || styles.error_message}>{message}</p>
}
